import * as React from "react";
import { IObservableArray } from "mobx";
import { inject } from "mobx-react";
import { FileLink } from "../General/FileLink";
import * as DocumentManagement from "../DocumentManagement";
import { MimeTypeIcon, IconType } from "../Icons/MimeTypeIcon";
import { Urls } from "../Urls";
import { AppStore } from "../Stores/AppStore";
import { Strings } from "../Stores/StringsStore";
import * as UiStore from "../States/AreaUiInfo";

export interface IDocumentEditFilesProps extends UiStore.IAreaUiInfo {
	files: IObservableArray<DocumentManagement.FileDetails>;
	isNew: boolean;
	params: IDocumentEditFilesPropsParams;
}

interface IDocumentEditFilesPropsParams {
	collection: string;
	id: string;
}

@inject("areaUiInfo")
export class DocumentEditFiles extends React.Component<
	IDocumentEditFilesProps,
	{}
> {
	onFileManagementButtonClick = () => {
		let parts = window.location.href.split("?");
		let queryString = parts.length > 1 ? "?" + parts[1] : "";
		let url = `${Urls.collections}/${this.props.params.collection}/documents/${this.props.params.id}/files/${AppStore.context.sessionDetails.uiLanguage}${queryString}`;
		AppStore.keepOnPage(url, true, this.props.areaUiInfo.closeExpand);
	};

	render() {
		let files: DocumentManagement.FileDetails[] = this.props.files.filter(
			(f) => f.isActive
		);
		let langsFound: string[] = [];
		files = files.filter((f) => {
			let isContentLanguage =
				f.language === null ||
				AppStore.context.contentLanguages.some(
					(l) => l.name === f.language
				);
			let contains = langsFound.some((l) => l === f.language);
			if (!contains) {
				langsFound.push(f.language);
			}
			return !contains && isContentLanguage;
		});
		files = files.sort((a, b) => {
			if (a.language === null) return -1;
			if (b.language === null) return 1;
			if (a.languageName < b.languageName) return -1;
			if (a.languageName > b.languageName) return 1;
			return 0;
		});

		return (
			<div className="list-object fileView">
				<ul>
					{files.length > 0 ? (
						files.map((file) => {
							return (
								<DocumentEditFile
									key={file.guid}
									file={file}
									params={this.props.params}
								/>
							);
						})
					) : (
						<div
							className="inside__note is--clickable-note"
							onClick={
								!this.props.isNew
									? this.onFileManagementButtonClick
									: () => {}
							}
							style={
								this.props.isNew ? { cursor: "default" } : {}
							}
						>
							<span>
								{this.props.isNew
									? Strings.documentManagement.documentEdit
											.newDocumentEmptyFilesResultText
									: Strings.documentManagement.documentEdit
											.documentEmptyFilesResultText}
							</span>
						</div>
					)}
				</ul>
			</div>
		);
	}
}

export interface IDocumentEditFileProps {
	file: DocumentManagement.FileDetails;
	params: IDocumentEditFilesPropsParams;
}

export class DocumentEditFile extends React.Component<
	IDocumentEditFileProps,
	{}
> {
	render() {
		return (
			<li
				data-test-name="documentFile"
				data-test-id={this.props.file.name.value}
				key={this.props.file.guid}
			>
				<div>
					<div className="list-object__tools">
						<div className="tinytool">
							<span className="tinytool__info">
								{Math.ceil(this.props.file.size / 1024)} kB
							</span>
							{this.props.file.created ? (
								<span className="tinytool__info">
									{this.props.file.created}
								</span>
							) : null}
						</div>
					</div>
					<div
						className="list-object__name"
						style={{
							display: "flex",
							flexDirection: "row",
							gap: "6px",
						}}
					>
						{this.props.file.region.toLowerCase() == "001" ? (
							<i>
								<img
									title={this.props.file.languageName}
									src={
										"../../images/flags/" +
										this.props.file.region +
										".png"
									}
								/>
							</i>
						) : (
							<div
								title={this.props.file.languageName}
								className={
									"flag flag-" +
									this.props.file.region.toLowerCase()
								}
							/>
						)}

						<FileLink
							documentId={this.props.params.id}
							language={this.props.file.language}
							guid={this.props.file.guid}
							mimeType={this.props.file.mimeType}
							name={this.props.file.name.value}
							testName="fileLink"
						/>
					</div>
				</div>
			</li>
		);
	}
}
